import icon from 'assets/images/rocket.svg'

import SubscriptionPlan from 'components/SubscriptionPlan'

const standard = [
  'Stripe Integration',
  'Google Analytics Integrations',
  'GitHub Integration',
  'No Daily Limits'
]

const Billing = props => (
  <div className='col-5'>
    <div className='settings-title center'>Subscription Plans</div>
    <div className='center-h'>
      <SubscriptionPlan
        title='Standard'
        icon={icon}
        price={27.95}
        benefits={standard}
        onClick={props.onSelectPlan}
      />
    </div>
  </div>
)

export default Billing
